import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Essay from "./Essay";
import Photo from "./Photo";
import InstagramPhoto from "./InstagramPhoto";
import Question from "./Question";

import "./index.scss";

const ProfileComment = ({ className, animated, onRemove, ...props }) => {
	const CommentType = ProfileComment.typeMap[props.comment_type];

	// We don't recognize this comment type.
	// Maybe try adding it to the typeMap?
	if (!CommentType) {
		console.error("Unsupported comment type!", props);

		return null;
	}

	return (
		<div className={classnames("profile-comment-widget", className, {
			[`profile-comment-widget--${props.comment_type}`]: true,
			"profile-comment-widget--animated": animated,
		})}>
			<CommentType {...props.comment_content} />
			{onRemove && (
				<button className="profile-comment-widget-close" onClick={onRemove}>
					<span className="icon i-close" />
				</button>
			)}
		</div>
	);
};

// List of possible comment types.
ProfileComment.type = {
	Essay: "essay",
	Photo: "photo",
	InstagramPhoto: "instagram_photo",
	Question: "question",
};

// Map comment types to components.
ProfileComment.typeMap = {
	[ProfileComment.type.Essay]: Essay,
	[ProfileComment.type.Photo]: Photo,
	[ProfileComment.type.InstagramPhoto]: InstagramPhoto,
	[ProfileComment.type.Question]: Question,
};

ProfileComment.propTypes = {
	className: PropTypes.string,
	animated: PropTypes.bool,
	onRemove: PropTypes.func,

	comment_type: PropTypes.oneOf(Object.values(ProfileComment.type)).isRequired,
	comment_content: PropTypes.object.isRequired,
};

ProfileComment.defaultProps = {
	className: undefined,
	animated: false,
	onRemove: null,
};

export default ProfileComment;



// WEBPACK FOOTER //
// ./src/shared/components/ProfileComment/index.jsx